// extracted by mini-css-extract-plugin
export var button = "_am-0";
export var icon = "_am-1";